// extracted by mini-css-extract-plugin
export default {"max-lines":"title_max-lines__KLdm6","maxLines":"title_max-lines__KLdm6"};